import { Box, Drawer, Stack, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import LegalSearchSidebar from "../../components/layout/LegalSearchSidebar";
import SearchResults from "../../components/SearchResults";
import CaseDetailDialog from "../../dialogs/CaseDetailDialog";
import { findCaseDetailByBookmarkId } from "../../actions/searchActions";

export const CaseSearch = () => {
  const [caseLawSearchQuery, setCaseLawSearchQuery] = useState("");
  const [caseLawCurrentPage, setCaseLawCurrentPage] = useState(1);
  const [caseLawSortBy, setCaseLawSortBy] = useState("Most Relevant");
  const [caseLawSearchMode, setCaseLawSearchMode] = useState("keyword");
  const [caseLawResultsCount, setCaseLawResultsCount] = useState(10);
  const [isNewCaseLawSearch, setIsNewCaseLawSearch] = useState(false);
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [openCaseInsights, setOpenCaseInsights] = useState(false);

  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const toggleSidebarVisibility = () => setIsSidebarVisible(!isSidebarVisible);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { caseId } = useParams();

  const handleOpenCaseInsights = (value) => {
    setOpenCaseInsights(value);
    if (value) window.dispatchEvent(new Event("closeHomeSidebar"));
  };

  useEffect(() => {
    if (!caseId) return;
    dispatch(findCaseDetailByBookmarkId(caseId));
    handleOpenCaseInsights(true);
  }, [caseId]);

  const handleCloseCaseInsights = () => {
    setOpenCaseInsights(false);
    if (caseId) {
      navigate("/app/searchResults", { replace: true });
    }
  };

  const commonSidebarProps = {
    toggleSidebar: toggleSidebarVisibility,
    searchKeyword: caseLawSearchQuery,
    currentPage: caseLawCurrentPage,
    setCurrentPage: setCaseLawCurrentPage,
    isNewCaseLawSearch,
    setIsNewCaseLawSearch,
    searchMode: caseLawSearchMode,
    sortBy: caseLawSortBy,
    resultsCount: caseLawResultsCount,
    activeTab,
  };

  return (
    <Stack
      direction="row"
      height="100%"
      width="100%"
      sx={{ backgroundColor: "#FFFFFF" }}
    >
      {isMobileView ? (
        <Drawer
          anchor="left"
          open={isSidebarVisible}
          onClose={toggleSidebarVisibility}
        >
          <LegalSearchSidebar
            {...commonSidebarProps}
            sideBarState={isSidebarVisible}
          />
        </Drawer>
      ) : (
        <LegalSearchSidebar {...commonSidebarProps} />
      )}

      {!openCaseInsights && (
        <SearchResults
          toggleSidebar={toggleSidebarVisibility}
          searchKeyword={caseLawSearchQuery}
          setSearchKeyword={setCaseLawSearchQuery}
          currentPage={caseLawCurrentPage}
          setCurrentPage={setCaseLawCurrentPage}
          setIsNewCaseLawSearch={setIsNewCaseLawSearch}
          searchMode={caseLawSearchMode}
          updateSearchMode={setCaseLawSearchMode}
          sortBy={caseLawSortBy}
          updateSortBy={setCaseLawSortBy}
          resultsCount={caseLawResultsCount}
          updateResultsCount={setCaseLawResultsCount}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setOpenCaseInsights={handleOpenCaseInsights}
        />
      )}

      <CaseDetailDialog
        open={openCaseInsights}
        onClose={handleCloseCaseInsights}
      />
    </Stack>
  );
};
